module.exports = __webpack_public_path__ + "static/maple-lodge-44b3a4df601a1db4ff2fef128eddb33b.png";